import _isString from 'lodash/isString';
import _random from 'lodash/random';

// Lists
const notificationLevels = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

// Utils
const buildNotificationContent = (content) => (
  _isString(content) ? {
    template: 'simpleText',
    params: {
      id: content,
    },
  } : content
);

const buildNotification = (level, content, icon, persist) => ({
  id: _random(10000, 99999),
  level,
  content: buildNotificationContent(content),
  icon,
  persist,
  date: new Date(),
});

const buildSuccessNotification = (content, icon = 'notificationSuccess', persist = false) => (
  buildNotification(notificationLevels.success, content, icon, persist)
);
const buildInfoNotification = (content, icon = 'notificationInfo', persist = true) => (
  buildNotification(notificationLevels.info, content, icon, persist)
);
const buildWarningingNotification = (content, icon = 'notificationWarning', persist = true) => (
  buildNotification(notificationLevels.warning, content, icon, persist)
);
const buildErrorNotification = (content, icon = 'notificationError', persist = true) => (
  buildNotification(notificationLevels.error, content, icon, persist)
);

/**
* Model
*/
const notification = {
  // Name
  name: 'notification',

  // List
  levels: notificationLevels,

  // Utils
  buildSuccess: buildSuccessNotification,
  buildInfo: buildInfoNotification,
  buildWarning: buildWarningingNotification,
  buildError: buildErrorNotification,
};

module.exports = notification;



// WEBPACK FOOTER //
// ./models/notification.js